import gql from 'graphql-tag'

export const GET_EVENT_GROUPS_WITH_GUESTS = gql`
  query getEventGroupsWithGuests($id: ID!) {
    me {
      id
      ... on Customer {
        myEventInfo(id: $id) {
          ...ManageGroupsEventFields
        }
      }
      ... on Concierge {
        myEventInfo(id: $id) {
          ...ManageGroupsEventFields
        }
      }
      ... on Admin {
        myEventInfo(id: $id) {
          ...ManageGroupsEventFields
        }
      }
    }
  }
  fragment ManageGroupsEventFields on MyEvent {
    id
    groups {
      id
      name
      description
    }
    guests {
      id
      firstName
      lastName
      group {
        primaryContact
        group {
          id
        }
      }
    }
  }
`

export const CREATE_GROUP = gql`
  mutation createGroup($eventId: ID!, $input: GroupInput!) {
    createGroup(eventId: $eventId, input: $input) {
      errors {
        key
        message
      }
      result {
        id
        name
        description
      }
    }
  }
`

export const UPDATE_GROUP = gql`
  mutation updateGroup($groupId: ID!, $input: GroupInput!) {
    updateGroup(groupId: $groupId, input: $input) {
      errors {
        key
        message
      }
      result {
        id
        name
        description
      }
    }
  }
`

export const DELETE_GROUP = gql`
  mutation deleteGroup($groupId: ID!) {
    deleteGroup(groupId: $groupId) {
      errors {
        key
        message
      }
      result {
        id
      }
    }
  }
`

export const SET_PRIMARY_CONTACT = gql`
  mutation setPrimaryContact($groupId: ID!, $guestId: ID!) {
    setPrimaryContact(groupId: $groupId, guestId: $guestId) {
      errors {
        key
        message
      }
      result {
        id
        primaryContact
        group {
          id
        }
      }
    }
  }
`
